// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rb-2";
export var chatLink = "_rb-0";
export var chatText = "_rb-1";